import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class BillingAdmin extends Model {
  [Type] = 'billing-admin' as const;

  @attr('string') declare contactId: string;
  @attr('string') declare email: string;
  @attr('string') declare errorMessage: string | null;
  @attr('string') declare firstName: string;
  @attr('string') declare lastName: string;
}
